import { render, staticRenderFns } from "./SalaryReportChartDatapointMenu.vue?vue&type=template&id=55454534&scoped=true&"
import script from "./SalaryReportChartDatapointMenu.vue?vue&type=script&lang=js&"
export * from "./SalaryReportChartDatapointMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55454534",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VDivider,VMenu})
